import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";

import $ from "jquery";

import {
  Paper,
  TextField,
  IconButton,
  InputAdornment,
  FormControl,
  InputLabel,
  Input,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
  Card,
  CardContent,
  Typography,
  CardHeader,
  Divider,
  AppBar,
  Tabs,
  Tab,
  Fab,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  CircularProgress
} from "@material-ui/core";

import {
  Visibility,
  VisibilityOff,
  WarningOutlined,
  CheckOutlined,
  Edit,
  EditOutlined,
  CheckBoxOutlined,
  CheckBoxOutlineBlankOutlined,
  CloudDownloadOutlined,
  CategoryOutlined,
  TimerOutlined,
  CalendarTodayOutlined,
  AddOutlined,
  ClearOutlined
} from "@material-ui/icons/";
import { generateKeyPair } from "crypto";
import NteApproval from "../../components/nte-approval/nte-approval";

const defaultFontSize = "2rem";

const styles = theme => ({
  formCls: {
    width: "99%"
  },
  root: {
    flexGrow: 1,
    display: "flex"
  },
  table: {
    // minWidth: 650
  },
  checkBoxColor: {
    color: "grey"
  },
  selected: {
    color: "#ff6c00 !important"
  },
  padding25: {
    padding: ".5rem"
  },
  margingrl25: {
    margin: "0 .25rem"
  },
  mb5: {
    marginBottom: ".5rem"
  },
  mb1rem: {
    marginBottom: "1rem"
  },
  mbwait: {
    marginBottom: "5rem"
  },
  ml1: {
    marginLeft: ".5rem"
  },
  mt1: {
    marginTop: ".5rem"
  },
  mr1: {
    marginRight: ".5rem"
  },
  woGroup: {
    display: "flex",
    justifyContent: "space-between",
    padding: ".5rem"
  },
  woInput: {
    width: "rem"
  },
  editIcon: {
    color: "orange"
  },
  dflex: {
    display: "flex"
  },
  flexg1: {
    flexGrow: 1
  },
  cardItem: {
    flexGrow: 1,
    // maxWidth: "15rem",
    // maxHeight: "15rem",
    overflow: "auto",
    margin: "0 .25rem"
  },
  cardMain: {
    flexGrow: 1,
    // maxWidth: "15rem",
    // maxHeight: "15rem",
    overflow: "auto",
    margin: "0 .25rem"
  },
  alignc: {
    alignSelf: "center"
  },
  alignfe: {
    alignSelf: "flex-end"
  },
  bg0: {
    backgroundColor: "#67625d82"
  },
  bg1: {
    backgroundColor: "#ff8a009c"
  },
  bg2: {
    backgroundColor: "#30b533b5"
  },
  bg3: {
    backgroundColor: "#3079b5b3"
  },
  bg4: {
    backgroundColor: "#7acada5c"
  },
  dividerItem: {
    margin: ".5rem 0 1rem 0"
  },
  descriptionItem: {
    flexGrow: 1,
    "& label": {
      fontWeight: "bolder",
      fontSize: "1.25rem",
      color: "black",
      textDecoration: "underline"
    },
    "& div > textarea": {
      color: "rgba(0, 0, 0, 0.38)"
      // cursor: default;
    }
  },
  flexcol: {
    flexDirection: "column"
  },
  addNoteItem: {
    display: "flex",
    width: "100%",
    justifyContent: "flex-end",
    alignItems: "center"
  },
  addnoteLabel: {
    marginRight: ".5rem"
  },
  fab: {
    color: "#30b533b5"
  },
  fabClose: {
    backgroundColor: "#cc1e1ede"
  },
  flexend: {
    justifyContent: "flex-end"
  },
  alignItemsCenter: {
    alignItems: "center"
  },
  nteButton: {
    display: "flex",
    alignItems: "flex-end"
    // marginBottom: ".5rem"
  },
  marginTB1: {
    margin: "1rem 0"
  },
  headerStyle: {
    color: "#6975c3"
  },
  restrictedCol:{
    width:"10rem",
    maxWidth:"10rem"
  }
});

function TabContainer({ children, dir }) {
  return (
    <Typography component="div" dir={dir} style={{ padding: 8 * 3 }}>
      {children}
    </Typography>
  );
}

class WorkOrderDetails extends Component {
  constructor() {
    super();

    this.state = {
      isProd: true,
      orderNumber: "Order Number",
      trackingNumber: "Tracking Number",
      createdDate: "Date Not Set",
      mode: 0,
      checkinColumns: ["Checkin", "Checkout", "Status"],
      checkinRows: [
        { Checkin: "1/1/2012", Checkout: "12/12/2012", Status: "Completed" }
      ],
      notesColumns: ["TimeStamp", "Author", "Note"],
      notesRows: [
        { TimeStamp: "1/1/2012", Author: "Angel", Note: "Completed" }
      ],

      billingCatergory: "Billing Catergory",
      responseCategory: "Reponse Category",
      nextSchedule: "Next Scedule",
      customerDescription: "Customer Description",
      callDescription: "Call Description",
      storePhone: "Store Phone",
      storeNumber: "Store Number",
      storeAddress: "Store Address",

      noteText: "",
      noteCreateIsVisible: false,

      isLoading: true,
      nteAvail:false,

      nteAmount: "",
      nteStatus: "",
      nteId: -1
    };
  }

  componentWillMount = () => {
    console.log(this.props.workOrder);
    if (this.props.workOrder) {
      this.getWorkOrderDetails();
      //this.fakeGetWorkOrderDetails();
    }
  };

  handleModeChange(mode) {
    this.setState({
      mode
    });
  }

  getOpenWorkOrders() {
    let url = this.state.isProd
      ? `/api/getOpenWorkOrders`
      : `https://localhost:44331/api/getOpenWorkOrders`;

    $.ajax({
      type: "POST",
      url: url,
      //   data: { filterterm: this.state.filterTerm },
      success: result => {
        let resultFormed = JSON.parse(result);
        console.log({ resultFormed });

        //   if(resultFormed.result !== 0){
        //     this.props.loginEvent(resultFormed.result);
        //     return;
        //   }

        // this.setState({
        //   storeItems: resultFormed.results
        // });

        this.parseData(resultFormed.results);
      },
      error: result => {
        console.error(result);
      }
    });
  }

  parseData = data => {
    let columnNames = Object.keys(data[0]);
    let rows = Object.values(data);

    return { columnNames, rows };
  };

  getText() {
    return `
    Bath and Body Works - FMO
    123 Main
    Houston, Tx 77061
    `;
  }

  handleChange = (evt, mode) => {
    this.setState({
      mode
    });
  };

  fakeGetWorkOrderDetails = () => {
    let result = `{"results":{"CustomerDescription":"General Maintenance-PM","AfterCallDescription":"General Maintenance-PM","BillingCategory":"PM","ResponsivenessCategory":"Not Categorized","PublicNotes":[],"checkInOutDates":[],"OrderNumber":"256618","Status":"Open","TrackingNumber":"","NTE":"$240.86","StoreID":1009,"FutureSchedule":"07/30/2019 12:15"},"storeDetails":{"StoreID":1009,"CustomerAbbreviation":"BBW","StoreNumber":"185","StoreAddress":"5488 S. Padre Island Corpus Christi, TX, 78411","PhoneNumber":"361-992-5331"},"isSuccessful":true}`;
    let resultFormed = JSON.parse(result);
    this.assignData(resultFormed.results, resultFormed.storeDetails);
  };
  getWorkOrderDetails = () => {
    let url = this.state.isProd
      ? `/api/getOrderDetails`
      : `https://localhost:44331/api/getOrderDetails`;

    $.ajax({
      type: "POST",
      url: url,
      data: { workOrder: this.props.workOrder },
      success: result => {
        console.log({ details: result });
        let resultFormed = JSON.parse(result);
        this.assignData(resultFormed.results, resultFormed.storeDetails);
        console.log({ results: resultFormed.results });
      },
      error: result => {
        console.error(result);
      }
    });
  };
  resetData = () => {
    this.setState({
      orderNumber: "",
      trackingNumber: "",
      createdDate: "",
      mode: 0,
      checkinColumns: [],
      checkinRows: [],
      notesColumns: [],
      notesRows: [],

      billingCatergory: "",
      responseCategory: "",
      nextSchedule: "",
      customerDescription: "",
      callDescription: "",
      storePhone: "",
      storeNumber: "",
      storeAddress: "",

      nteAmount: "",
      nteStatus: "",
      nteId: -1
    });
  };
  assignData = (data, store) => {
    this.resetData();

    this.setState({
      billingCatergory: data.BillingCategory,
      responseCategory: data.ResponsivenessCategory,
      callDescription: data.AfterCallDescription,
      customerDescription: data.CustomerDescription,
      orderNumber: data.OrderNumber,
      trackingNumber: data.TrackingNumber,
      createdDate: data.CreatedDate,
      nextSchedule: data.FutureSchedule,
      storeAddress: store.StoreAddress,
      storeNumber: store.StoreNumber,
      storePhone: store.PhoneNumber,
      isLoading: false,
      nteAvail: data.DoesNTEexist && data.NteDetail.ShouldBeAccessible,
      nteAmount: data.NTE,
      nteStatus: data.NteDetail.Status,
      nteIsPending: data.NteDetail.IsPending,
      nteId: data.NteDetail.NteID
    });

    if (data.checkInOutDates && data.checkInOutDates.length > 0) {
      this.assignCheckinData(data.checkInOutDates);
    }

    if (data.PublicNotes && data.PublicNotes.length > 0) {
      this.assignNotesData(data.PublicNotes);
    }
  };

  assignNotesData = data => {
    let info = this.parseData(data);
    this.setState({
      notesColumns: info.columnNames.reverse(),
      notesRows: info.rows.reverse()
    });
  };

  assignCheckinData = data => {
    let info = this.parseData(data);
    this.setState({
      checkinColumns: info.columnNames,
      checkinRows: info.rows
    });
  };

  handleNoteUpdate = evt => {
    this.setState({
      noteText: evt.target.value
    });
  };

  handleCreateNote = () => {
    let url = this.state.isProd
      ? `/api/createNote`
      : `https://localhost:44331/api/createNote`;

    $.ajax({
      type: "POST",
      url: url,
      data: { ordernumber: this.state.orderNumber, note: this.state.noteText },
      success: result => {
        debugger;

        let resultFormed = JSON.parse(result);

        if (resultFormed.results && resultFormed.isSuccessful) {
          this.setState(
            {
              noteText: ""
            },
            () => this.updateNotes()
          );
        }
      },
      error: result => {
        console.error(result);
      }
    });
  };

  updateNotes = () => {
    this.handleNotesClose();
    this.getUpdatedNotes();
  };

  handleOpenNotes = () => {
    this.setState({
      noteCreateIsVisible: true
    });
  };

  handleNotesClose = () => {
    this.setState({
      noteCreateIsVisible: false
    });
  };

  getUpdatedNotes = () => {
    let url = this.state.isProd
      ? `/api/getNotes`
      : `https://localhost:44331/api/getNotes`;

    $.ajax({
      type: "POST",
      url: url,
      data: { workOrder: this.props.workOrder },
      success: result => {
        debugger;
        let resultFormed = JSON.parse(result);
        this.assignNotesData(resultFormed.results);
        console.log({ results: resultFormed.results });
      },
      error: result => {
        console.error(result);
      }
    });
  };

  fetchFile = () => {
    
    let urlAdd = this.state.isProd
      ? `${window.location.href}api/getFile`
      : `https://localhost:44331/api/getFile`;

    let url = new URL(urlAdd);
    let params = { ordernumber: this.state.orderNumber };
    Object.keys(params).forEach(key =>
      url.searchParams.append(key, params[key])
    );

    fetch(url)
      .then(function(response) {
        return response.blob();
      })
      .then(function(blob) {
        var url = window.URL.createObjectURL(blob);
        var a = document.createElement("a");
        a.href = url;
        a.download = "nte.pdf";
        document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
        a.click();
        a.remove();
      });
  };

  nteEvent = (nte, nteDetail) => {

    this.setState({
      nteAmount: nte,
      nteStatus: nteDetail.Status,
      nteIsPending: nteDetail.IsPending,
      nteId: nteDetail.NteID
    });

  };

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        {this.state.isLoading ? (
          <Paper
            className={[
              classes.dflex,
              classes.flexcol,
              classes.flexg1,
              classes.padding25,
              classes.justifyContent,
              classes.alignItemsCenter
            ].join(" ")}
          >
            <Typography variant="h4" className={classes.mbwait}>
              Retrieving Work Order :{" "}
              {<strong>{this.state.orderNumber}</strong>}...
            </Typography>
            <CircularProgress />
          </Paper>
        ) : (
          <Paper className={[classes.flexg1, classes.padding25].join(" ")}>
            <Typography
              variant="h4"
              gutterBottom
              align="center"
              className={classes.headerStyle}
            >
              Work Order Details
            </Typography>

            <div className={classes.woGroup}>
              <Typography variant="h5" align="left">
                {`Tracking Number: ${this.state.trackingNumber}`}{" "}
              </Typography>

              <Typography variant="h5" align="right">
                {`Created: ${this.state.createdDate}`}{" "}
              </Typography>
            </div>

            <Divider className={classes.dividerItem} />

            <div className={[classes.dflex, classes.mb1rem].join(" ")}>
              <Card className={classes.cardMain}>
                <CardHeader
                  className={classes.bg0}
                  classes={{ action: classes.alignfe }}
                  title={`Order Number: ${this.state.orderNumber}`}
                />
                <CardContent className={[classes.dflex].join(" ")}>
                  <TextField
                    label="Store Address"
                    multiline
                    rowsMax="6"
                    value={this.state.storeAddress}
                    className={[classes.descriptionItem, classes.mr1].join(" ")}
                    margin="normal"
                  />
                  <div className={[classes.dflex, classes.flexcol].join(" ")}>
                    <TextField
                      id="standard-textarea"
                      label="Phone #"
                      className={[classes.textField, classes.mb1].join(" ")}
                      margin="normal"
                      value={this.state.storePhone}
                    />
                    <TextField
                      id="standard-textarea"
                      label="Store #"
                      className={[classes.textField, classes.mb1].join(" ")}
                      margin="normal"
                      value={this.state.storeNumber}
                    />
                  </div>
                </CardContent>
              </Card>

              <Card className={classes.cardItem}>
                <CardHeader
                  className={classes.bg4}
                  classes={{ action: classes.alignfe }}
                  action={
                    <Button
                      disabled={!this.state.nteAvail}
                      variant="contained"
                      size="small"
                      color="primary"
                      className={[classes.ml1].join(" ")}
                      onClick={this.fetchFile}
                    >
                      Download NTE
                      <CloudDownloadOutlined className={classes.ml1} />
                    </Button>
                  }
                  title={`NTE - (Status: ${this.state.nteStatus})`}
                />
                <CardContent>
                  <div className={[classes.dflex, classes.marginTB1].join(" ")}>
                    <TextField
                      label="NTE Amount"
                      value={this.state.nteAmount}
                      className={[classes.descriptionItem, classes.mr1].join(
                        " "
                      )}
                    />

                    <div className={classes.nteButton}>
                      <NteApproval
                        isDisabled={!this.state.nteIsPending}
                        workOrder={this.props.workOrder}
                        nteid={this.state.nteId}
                        nteEvent={this.nteEvent}
                      />
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>

            <div
              className={[classes.dflex, classes.mt1, classes.mb1rem].join(" ")}
            >
              <Card className={classes.cardItem}>
                <CardHeader
                  className={classes.bg1}
                  classes={{ action: classes.alignfe }}
                  action={<CategoryOutlined />}
                  title="Billing Category"
                />
                <CardContent>
                  <Typography variant="body2" component="p">
                    {this.state.billingCatergory}
                  </Typography>
                </CardContent>
              </Card>

              <Card className={classes.cardItem}>
                <CardHeader
                  className={classes.bg2}
                  classes={{ action: classes.alignfe }}
                  action={<TimerOutlined />}
                  title="Response Time"
                />
                <CardContent>
                  <Typography variant="body2" component="p">
                    {this.state.responseCategory}
                  </Typography>
                </CardContent>
              </Card>

              <Card className={classes.cardItem}>
                <CardHeader
                  className={classes.bg3}
                  classes={{ action: classes.alignfe }}
                  action={<CalendarTodayOutlined />}
                  title="Next Schedule"
                />
                <CardContent>
                  <Typography variant="body2" component="p">
                    {this.state.nextSchedule}
                  </Typography>
                </CardContent>
              </Card>
            </div>

            <div className={[classes.dflex, classes.mb1rem].join(" ")}>
              <TextField
                label="Customer Description"
                multiline
                rowsMax="6"
                value={this.state.customerDescription}
                className={[classes.descriptionItem, classes.mr1].join(" ")}
                margin="normal"
              />

              <TextField
                label="Call Description"
                multiline
                rowsMax="6"
                value={this.state.callDescription}
                className={classes.descriptionItem}
                margin="normal"
              />
            </div>

            <div className={[classes.mt1].join(" ")}>
              <AppBar position="static">
                <Tabs value={this.state.mode} onChange={this.handleChange}>
                  <Tab label="Notes" value={0} />
                  <Tab label="Check In/Out" value={1} />
                </Tabs>
              </AppBar>
              {this.state.mode === 0 ? (
                <TabContainer>
                  <div className={[classes.dflex, classes.flexcol]}>
                    <div className={classes.addNoteItem}>
                      <Typography
                        component="p"
                        className={classes.addnoteLabel}
                      >
                        Add Note
                      </Typography>
                      <Fab
                        color="primary"
                        aria-label="Add"
                        title="Add Note"
                        onClick={this.handleOpenNotes}
                      >
                        <AddOutlined />
                      </Fab>
                    </div>
                    <Table className={classes.table}>
                      <TableHead>
                        <TableRow>
                          {this.state.notesColumns.map((column, index) => (
                            <TableCell
                              className={index === 0 ? classes.restrictedCol : null}
                              align={index < 2 ? "center" : "left"}
                              key={column}
                            >
                              {column}
                            </TableCell>
                          ))}
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {this.state.notesRows.map((row, index) => (
                          <TableRow key={index} hover>
                            {this.state.notesColumns.map((column, index) => (
                              <TableCell
                                size={index === 0 ? "small" : "medium"}
                                align={index < 2 ? "center" : "left"}
                                key={column}
                              >
                                {row[column]}
                              </TableCell>
                            ))}
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </div>
                </TabContainer>
              ) : (
                <TabContainer>
                  <Table className={classes.table}>
                    <TableHead>
                      <TableRow>
                        {this.state.checkinColumns.map((column, index) => (
                          <TableCell
                            align={index < 2 ? "center" : "left"}
                            key={column}
                          >
                            {column}
                          </TableCell>
                        ))}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {this.state.checkinRows.map((row, index) => (
                        <TableRow key={index} hover>
                          {this.state.checkinColumns.map((column, index) => (
                            <TableCell
                              align={index < 2 ? "center" : "left"}
                              key={column}
                            >
                              {row[column]}
                            </TableCell>
                          ))}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TabContainer>
              )}
            </div>
          </Paper>
        )}

        <Dialog
          fullWidth={true}
          maxWidth="sm"
          // fullScreen
          open={this.state.noteCreateIsVisible}
          onClose={this.handleNotesClose}
        >
          <DialogTitle
            id="alert-dialog-title"
            className={[classes.dflex, classes.flexend].join(" ")}
          >
            <Fab
              color="primary"
              title="Close"
              className={classes.fabClose}
              onClick={this.handleNotesClose}
            >
              <ClearOutlined />
            </Fab>
          </DialogTitle>

          <DialogContent>
            <TextField
              autoFocus
              label="New Note"
              placeholder="Enter Note Content..."
              multiline
              rowsMax="6"
              value={this.state.noteText}
              onChange={this.handleNoteUpdate}
              className={[classes.descriptionItem, classes.mr1].join(" ")}
              margin="normal"
            />
          </DialogContent>

          <DialogActions>
            <Button
              onClick={this.handleCreateNote}
              color="primary"
              variant="contained"
            >
              Create Note
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export default withStyles(styles)(WorkOrderDetails);
